// @ts-ignore
// @ts-nocheck
import api from 'services/api';

type ContactsModel = {
  contact: string;
  contactId: string;
  contactIdSf?: string;
  contactType: string;
  isValidated: boolean;
  name: string;
  status: string;
  isNeedUpdate?: boolean;
};

type CustomerAddressesData = {
  addressLine: string;
  addressNumber: string;
  addressType: string;
  city: string;
  code: string;
  complement: string;
  contry: string;
  document: string;
  siteId: string;
  stateCode: string;
  zipCode: string;
  contacts: ContactsModel[];
};

export type UserDataResponse = {
  customerAddresses: CustomerAddressesData[];
};

const resolveContactNameByAddressType = (
  userData: UserDataResponse,
  siteId: string,
  contactIdSf: string,
  addressType: string
): string => {
  const address = userData.customerAddresses.find(
    (addr) => addr.siteId === siteId && addr.addressType === addressType
  );

  if (!address?.contacts?.length) {
    return '';
  }

  const responseContacts = address.contacts.filter(
    (contact) => contact.contactIdSf === contactIdSf
  );

  if (!responseContacts.length) {
    return '';
  }

  return responseContacts[0]?.name || responseContacts[1]?.name || '';
};

export const getContactDisplayName = (
  userData: UserDataResponse | undefined
): string => {
  if (!userData?.customerAddresses?.length) {
    return '';
  }

  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');
  const siteId = localStorage.getItem('@UltragazEmpresarial:customerSiteId');

  if (!contactIdSf || !siteId) {
    return '';
  }

  return (
    resolveContactNameByAddressType(userData, siteId, contactIdSf, 'SHIP_TO') ||
    resolveContactNameByAddressType(userData, siteId, contactIdSf, 'BILL_TO')
  );
};

export const getUserData = async (): Promise<UserDataResponse | undefined> => {
  const token = localStorage.getItem('@UltragazEmpresarial:accessToken');

  const header = {
    'Content-Type': 'application/json',
    access_token: token as string,
  };

  try {
    const res = await api.get('industrial/customer/v1/customers/me', {
      method: 'GET',
      headers: header,
    });
    if (res.data) {
      return res.data;
    }
  } catch (err) {
    console.error(err);
  }
};
